import React from "react";

const FourOhFour = () => <div className="View"><h1>Here you are</h1><p>Maybe you are lost or maybe you are a Summoner and your DAO has not registered yet.</p></div>;

export default FourOhFour;
